import type { Audience, ContentType } from "@/content/schema";
import type { ContentRecord } from "@/lib/content/load";

export const audienceFilters: { id: "all" | Audience; label: string }[] = [
  { id: "all", label: "All audiences" },
  { id: "business", label: "Business" },
  { id: "product-developer", label: "Product / developer" },
];

export const formatFilters: { id: "all" | ContentType; label: string }[] = [
  { id: "all", label: "All formats" },
  { id: "thinking-note", label: "Thinking" },
  { id: "linkedin-highlight", label: "LinkedIn highlights" },
  { id: "product-note", label: "Product notes" },
  { id: "workshop-brief", label: "Workshop briefs" },
];

export function filterThinking(
  records: ContentRecord[],
  audience: "all" | Audience,
  format: "all" | ContentType,
): ContentRecord[] {
  return records.filter((record) => {
    const audienceOk =
      audience === "all" || record.meta.audiences.includes(audience);
    const formatOk = format === "all" || record.meta.type === format;
    return audienceOk && formatOk;
  });
}

export function sourceLabel(type: ContentType): string {
  if (type === "linkedin-highlight") return "LinkedIn highlight";
  if (type === "product-note") return "Product note";
  if (type === "workshop-brief") return "Workshop brief";
  return "Thinking note";
}
